/**
 * Builds a hierarchical tree from a flat list of groups based on name prefixes (split by dot).
 * @param {Array} groups - The flat list of groups from Graph API.
 * @param {String} orgPrefix - The organization prefix (e.g., "KS").
 * @returns {Array} - The hierarchical tree structure.
 */
export function buildGroupTree(groups, orgPrefix) {
    if (!groups || groups.length === 0) {
        return [];
    }

    /*
    // 1. Filter groups that match the org prefix (case-insensitive)
    // The user said "KS" is the code. Group names are like "KS01.Name".
    // So we check if the name starts with the orgPrefix.
    const filteredGroups = groups.filter(g =>
        g.displayName.toUpperCase().startsWith(orgPrefix.toUpperCase())
    );

    // 2. Parse and sort
    // We need to extract the "Code" from "Code.Name"
    // e.g. "KS01.營業一處" -> Code: "KS01"
    const parsedGroups = filteredGroups.map(g => {
        // Split by dot
        const parts = g.displayName.split(/[.\s]+/);
        const code = parts[0]; // "KS01"
        return {
            ...g,
            code: code,
            children: []
        };
    });*/

    //2025/12/04 組織名稱格式修改: KS00050303.資訊部應用軟體組 -> 資訊部 應用軟體組.KS00050303
    console.log(orgPrefix);
    const parsedGroups = groups
        .map(g => {
            const parts = g.displayName.split(/[.\s]+/);
            const code = parts[parts.length - 1];
            return {
                ...g,
                code: code,
                children: []
            };
        })
        .filter(g => g.code.startsWith(orgPrefix)); // 只有 code 開頭為 orgPrefix 的才會留下

    // Sort by code length (shortest first) to help with parent finding, then by code    
    parsedGroups.sort((a, b) => {
        if (a.code.length !== b.code.length) {
            return a.code.length - b.code.length;
        }
        return a.code.localeCompare(b.code);
    });

    // 3. Build Hierarchy
    // For each group, find the "closest" parent.
    // A parent is a group whose code is a prefix of this group's code.
    // e.g. "KS01" is parent of "KS0101".
    // We want the *longest* prefix that is shorter than the current code.
    const rootGroups = []; //最上層的群組

    parsedGroups.forEach(group => {
        let hasParent = false;

        // Iterate over all other groups to find the best parent
        // Since we sorted by length, potential parents are likely before us, but not strictly required if we iterate all.
        // Optimization: We only need to check groups with shorter codes.

        parsedGroups.forEach(potentialParent => {
            if (group.id === potentialParent.id) return;

            // Check if potentialParent.code is a prefix of group.code
            if (group.code.startsWith(potentialParent.code)) {
                hasParent = true;
                return; 
            }
        });

        if (!hasParent) {
            rootGroups.push(group);
        }
    });
    return rootGroups;
}
